module.exports = __webpack_public_path__ + "static/fonts/Fact-CompressedMedium.9be39f2.woff";